import logging from '@wr/logging';
import {getErrorStatusCode} from '../components/pages/TrueLayerStatusWaiting/helpers';
import config from '../config';
import eventIds from '../event-ids';
import {throwOnResponseError} from '../utils/createResponseError';

const getTrueLayerPaymentStatus = async ({
    requestId, sessionId, query: {paymentSessionId}
}) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const logProps = {requestId, sessionId, paymentSessionId};

    logger.info('Retrieving TrueLayer payment status', {
        eventId: eventIds['Retrieving TrueLayer payment status'],
        ...logProps
    });

    try {
        const url = new URL(`/api/sessions/${paymentSessionId}`, config.trueLayerIntegrator.url);

        const statusResponse = await fetch(url.toString());

        throwOnResponseError(statusResponse);
        const statusData = await statusResponse.json();
        logger.info('Retrieved TrueLayer payment status', {
            eventId: eventIds['Retrieved TrueLayer payment status'],
            ...logProps,
            payload: statusData
        });

        return statusData;
    } catch (e) {
        const error = new Error(`Error retrieving TrueLayer payment status: ${e.message}`);
        error.status = getErrorStatusCode(e);
        logger.error(error.message, {
            eventId: eventIds['Error retrieving TrueLayer payment status'],
            ...logProps
        });

        throw error;
    }
};

export default getTrueLayerPaymentStatus;
